/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
// import Registration from "./Registration";
// import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { useSelector, shallowEqual } from "react-redux";
import Axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";
import { CircularProgress } from "@material-ui/core";
import SuperadminLogin from "./SuperAdminLogin";
import { CORPORATION } from "../../../config/environment";
import { CORPS } from "../../../config/helper";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

export function AuthPage() {
  const { host } = window.location;
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSuperadmin, setIsSuperadmin] = useState(false);
  const [redirect, setRedirect] = useState(null);

  const getLogo = () => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    setLoading(true);
    Axios.get(`${OrganizationURL}data`)
      .then(response => {
        setLoading(false);

        if (response.data.data.image) {
          setLogo(
            response.data.data.image.storage +
              "/" +
              response.data.data.image.path
          );
          link.href = response.data.data.image.storage + "/" + response.data.data.image.path;
        }
      })
      .catch(error => {
        setLoading(false);
        console.log("====================================");
        console.log(error);
        console.log("====================================");
      });
  };

  useEffect(() => {
    getLogo();
    if (window.location.pathname.includes("superadmin")) {
      setIsSuperadmin(true);
    }
  }, []);

  useEffect(() => {
    if (/^dd.simpz.id$/.test(host)) {
      setRedirect("/auth/superadmin/login");
    } else {
      setRedirect(null);
    }
  }, [host]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-2.jpg")})`
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              {!loading ? (
                <Link to="/" className="flex-column-auto mt-5 pb-lg-0 pb-10">
                  <img
                    alt="Logo"
                    className="max-h-70px"
                    // src={auth.user ? auth.user.organization.image ? `${auth.user.organization.image.storage}/${auth.user.organization.image.path}` : toAbsoluteUrl("/media/logos/donorian-logo.png") : toAbsoluteUrl("/media/logos/donorian-logo.png")}
                    src={
                      logo
                        ? logo
                        : CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                        ? toAbsoluteUrl("/media/logos/logo-letter-1.png")
                        : toAbsoluteUrl("/media/logos/donorian-logo.png")
                    }
                  />
                </Link>
              ) : (
                <CircularProgress />
              )}
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">
                  {isSuperadmin ? "Superadmin" : "Admin"}{" "}
                  {CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                    ? "SIMPZ"
                    : "Donorian"}
                </h3>
                <p className="font-weight-lighter text-white opacity-80">
                  <i>Sistem Informasi Mitra Pengelola Zakat</i>
                </p>
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy; 2022
                </div>
                <div className="d-flex">
                  <Link to="/terms" className="text-white">
                    Privacy
                  </Link>
                  <Link to="/terms" className="text-white ml-10">
                    Legal
                  </Link>
                  <Link to="/terms" className="text-white ml-10">
                    Contact
                  </Link>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            {/*<div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">*/}
            {/*  <span className="font-weight-bold text-dark-50">*/}
            {/*    Don't have an account yet?*/}
            {/*  </span>*/}
            {/*  <Link*/}
            {/*    to="/auth/registration"*/}
            {/*    className="font-weight-bold ml-2"*/}
            {/*    id="kt_login_signup"*/}
            {/*  >*/}
            {/*    Sign Up!*/}
            {/*  </Link>*/}
            {/*</div>*/}
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                {redirect && (
                  <Redirect from="/auth/login" to="/auth/superadmin/login" />
                )}
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute path="/auth/password/forgot" component={ForgotPassword} />
                <ContentRoute path="/auth/password/reset" component={ResetPassword} />
                <ContentRoute
                  path="/auth/superadmin/login"
                  component={SuperadminLogin}
                />
                {/*<ContentRoute*/}
                {/*  path="/auth/registration"*/}
                {/*  component={Registration}*/}
                {/*/>*/}
                {/*<ContentRoute*/}
                {/*  path="/auth/forgot-password"*/}
                {/*  component={ForgotPassword}*/}
                {/*/>*/}
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; 2022 Donorian
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/terms" className="text-dark-75 text-hover-primary">
                  Privacy
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Legal
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Contact
                </Link>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
